import { useState, useMemo } from 'react'
import { Button, FlexBox, Icon } from '@vp/swan'
import CountrySelector from '../../common/country-selector'
import { findCountryByCode } from '../../../utils/country'

interface CountrySelectorButtonProps {
  currentCountry: string
  localeSelectButtonA11yText: string
  locale: string
  tenant: string
  countrySelectorDialogHeader?: string
}

export const CountrySelectorButton: React.FC<CountrySelectorButtonProps> = ({
  currentCountry,
  localeSelectButtonA11yText,
  locale,
  tenant,
  countrySelectorDialogHeader,
}) => {
  const [isCountrySelectorOpen, setIsCountrySelectorOpen] = useState(false)

  const country = useMemo(() => findCountryByCode(currentCountry), [currentCountry])

  const openCountrySelector = () => setIsCountrySelectorOpen(true)
  const closeCountrySelector = () => setIsCountrySelectorOpen(false)

  return (
    <FlexBox justifyContent="flex-end" alignItems="center">
      <Button skin="tertiary" aria-label={localeSelectButtonA11yText?.replace('{{{ currentLocaleName }}}', country.text)} onClick={openCountrySelector} p={0}>
        <img src={country.imageUrl.image.url} alt="" width={24} height={24} />
        <Icon iconType="caretDown" size="20p" skin="white" aria-hidden="true" />
      </Button>
      {isCountrySelectorOpen && (
        <CountrySelector
          isOpen={isCountrySelectorOpen}
          handleClose={closeCountrySelector}
          locale={locale}
          tenant={tenant}
          selectedCountry={currentCountry}
          countrySelectorDialogHeader={countrySelectorDialogHeader}
        />
      )}
    </FlexBox>
  )
}
